module.exports = __webpack_public_path__ + "static/img/AboutPetSub.a85470c9.png";